import { Talent } from '../../Classes'

const tier6 = [null, null, new Talent('Darkness', 'spell_shadow_twilight', ['Increases your Shadow spell damage by ', '%.'], 5, [[2, 4, 6, 8, 10]]), null]

export default tier6
